/**
 * Атрибут accept для загрузки музыки в админке.
 * Один голый audio/* на iOS/WebView часто открывает выбор с преобладанием видео (mp4).
 */
export const ADMIN_AUDIO_FILE_ACCEPT = [
  'audio/mpeg',
  'audio/mp3',
  'audio/wav',
  'audio/x-wav',
  'audio/aac',
  'audio/x-aac',
  'audio/x-m4a',
  'audio/flac',
  'audio/ogg',
  'audio/opus',
  'audio/x-caf',
  '.mp3',
  '.m4a',
  '.aac',
  '.wav',
  '.flac',
  '.ogg',
  '.oga',
  '.opus',
  '.caf',
  '.aiff',
  '.aif',
  '.wma',
].join(',');
